/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { appleEventControllerHandleNotification } from '../fn/apple-event/apple-event-controller-handle-notification';
import { AppleEventControllerHandleNotification$Params } from '../fn/apple-event/apple-event-controller-handle-notification';

@Injectable({ providedIn: 'root' })
export class AppleEventService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appleEventControllerHandleNotification()` */
  static readonly AppleEventControllerHandleNotificationPath = '/api/apple-event/notifications';

  /**
   * Apple Server-to-Server Notifications.
   *
   * Receives and processes server-to-server notifications from Apple.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appleEventControllerHandleNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  appleEventControllerHandleNotification$Response(params?: AppleEventControllerHandleNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appleEventControllerHandleNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Apple Server-to-Server Notifications.
   *
   * Receives and processes server-to-server notifications from Apple.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appleEventControllerHandleNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appleEventControllerHandleNotification(params?: AppleEventControllerHandleNotification$Params, context?: HttpContext): Observable<void> {
    return this.appleEventControllerHandleNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
